import { useState, useMemo, useEffect } from "react";
import axios from "axios";

export default function useVendorItems() {
  // ⭐ Hard-coded Stall ID
  const stallId = "96f3ef34-f855-44df-9821-c1da2074ede7";

  const [search, setSearch] = useState("");
  const [filterType, setFilterType] = useState("All");
  const [items, setItems] = useState([]);
  const [stallDetails, setStallDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  // =============================================
  // ⭐ Fetch items & stall details from backend
  // =============================================
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Fetch items
        const itemsRes = await axios.get(
          `https://fliplyn-b-c.fly.dev/items/stall/${stallId}`
        );

        // ⭐ Map API fields into your UI format
        const formattedItems = itemsRes.data.map((item) => ({
          id: item.id,
          name: item.name,
          type: item.is_veg ? "Veg" : "Non Veg",
          price: `₹${item.final_price}`,
          gst: item.tax_included ? "Inc. GST" : "Excl. GST",
          category: item.category_id,
          available: item.is_available,
          image: item.image_url,
        }));

        setItems(formattedItems);

        // Fetch stall details
        const stallRes = await axios.get(
          `https://fliplyn-b-c.fly.dev/stalls/${stallId}`
        );

        setStallDetails(stallRes.data);
      } catch (error) {
        console.error("Error fetching items or stall details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // =============================================
  // ⭐ Toggle availability (frontend only)
  // =============================================
  const handleToggleAvailability = (id) => {
    setItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, available: !item.available } : item
      )
    );
  };

  // =============================================
  // ⭐ Filter + Search with useMemo
  // =============================================
  const filteredItems = useMemo(() => {
    return items.filter((item) => {
      const matchesSearch = item.name
        .toLowerCase()
        .includes(search.toLowerCase());

      if (filterType === "Available") return item.available && matchesSearch;
      if (filterType === "Paused") return !item.available && matchesSearch;
      return matchesSearch;
    });
  }, [items, search, filterType]);

  return {
    loading,
    stallDetails,
    search,
    setSearch,
    filterType,
    setFilterType,
    items,
    filteredItems,
    handleToggleAvailability,
  };
}
